import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, CalendarClock, KeyRound, Building2, ArrowRight } from "lucide-react";
import { listServices, mediaUrl } from "../lib/api";

const CATEGORIES = [
  { key: "short_term", label: "Location courte durée", Icon: CalendarClock },
  { key: "long_term", label: "Location longue durée", Icon: KeyRound },
  { key: "management", label: "Gestion immobilière", Icon: Building2 },
];

export default function ServicesSection() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    listServices().then(setServices).catch(() => setServices([]));
  }, []);

  if (services.length === 0) return null;

  return (
    <section id="locations" className="py-24 glass-light border-t border-white/40">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="reveal text-[#2f74c9] tracking-[0.3em] text-xs uppercase mb-3">
            Locations & gestion
          </p>
          <h2 className="reveal font-serif-display text-3xl md:text-4xl text-[#0b1f33]">
            Vos revenus locatifs, entre de bonnes mains
          </h2>
          <p className="reveal reveal-delay-1 text-slate-500 mt-4 max-w-2xl mx-auto">
            De la location de vacances à la location à l'année, nous gérons tout
            pour vous &mdash; propulsé par une intégration Guesty.
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {CATEGORIES.map((cat, idx) => {
            const item = services.find((s) => s.category === cat.key);
            if (!item) return null;
            const reversed = idx % 2 === 1;
            const Icon = cat.Icon;
            return (
              <div
                key={cat.key}
                className="reveal grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-center"
              >
                {/* image */}
                <div className={`relative h-72 md:h-96 rounded-lg overflow-hidden ${reversed ? "md:order-2" : ""}`}>
                  <img src={mediaUrl(item.image)} alt={item.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f33]/40 to-transparent" />
                  <span className="absolute top-5 left-5 inline-flex items-center gap-2 bg-white/95 text-[#0b1f33] text-xs font-600 px-3 py-1.5 rounded-full">
                    <Icon size={15} className="text-[#2f74c9]" /> {cat.label}
                  </span>
                </div>

                {/* content */}
                <div className={reversed ? "md:order-1" : ""}>
                  <div className="flex items-center gap-2 text-[#2f74c9] mb-3">
                    <Icon size={20} />
                    <span className="text-xs uppercase tracking-[0.25em]">{cat.label}</span>
                  </div>
                  <h3 className="font-serif-display text-3xl text-[#0b1f33] leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-slate-500 mt-4 leading-relaxed">{item.description}</p>

                  {item.features && item.features.length > 0 && (
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6">
                      {item.features.map((f) => (
                        <li key={f} className="flex items-center gap-2 text-sm text-slate-700">
                          <span className="w-5 h-5 rounded-full bg-[#2f74c9]/10 flex items-center justify-center shrink-0">
                            <Check size={13} className="text-[#2f74c9]" />
                          </span>
                          {f}
                        </li>
                      ))}
                    </ul>
                  )}

                  <div className="flex flex-wrap items-center gap-4 mt-8">
                    <Link
                      to={item.cta_link || "/contact"}
                      className="btn-gold inline-flex items-center gap-2 px-7 py-3.5 rounded-sm font-600"
                    >
                      {item.cta_label || "En savoir plus"} <ArrowRight size={16} />
                    </Link>
                    {cat.key === "management" && (
                      <span className="text-xs text-slate-400 tracking-wide">
                        Propulsé par <span className="text-[#2f74c9] font-600">Guesty</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
